import React from 'react';
import t from '@jetshop/intl';
import styled from 'react-emotion';

const Empty = styled('div')`
  text-align: center;
  color: gray;
  padding: 3rem 0 2rem 0;
  font-size: 1.8rem;
`;

const EmptySearchResults = ({ term, result }) => {
  return <Empty>{t('No results for {term}', { term })}</Empty>;
};

export default EmptySearchResults;
